export { default } from './SettingsAnonym.jsx';
